import { SegmentationIds } from 'constants/segmentation';
import {
  ProductSegmentation,
  SegmentationData,
} from 'modules/product-details/types';

export const resolveSegmentUsps = (
  segmentation: ProductSegmentation['segmentation'],
  segmentId: SegmentationIds
): SegmentationData['usps'] | null => {
  const productSegmentData = segmentation[segmentId] as SegmentationData | null;

  if (!productSegmentData) {
    return null;
  }
  const { usps } = productSegmentData;

  if (usps) return usps;
  return null;
};
